import { Globe } from 'lucide-react';
import { AnimatePresence } from 'framer-motion';
import { AdminData } from '../AdminLoader';
import { TableSection, LoadingState, EmptyState, UserRow } from './TableComponents';
import { useIsMobile } from '../../../hooks/useIsMobile';

interface GlobalAdminTableProps {
  isLoading: boolean;
  admins: AdminData[];
  getUserName: (admin: AdminData) => string;
}

export const GlobalAdminTable = ({ isLoading, admins, getUserName }: GlobalAdminTableProps) => {
  const isMobile = useIsMobile();

  const splitAdmins = () => {
    const midpoint = Math.ceil(admins.length / 2);
    const leftColumn = admins.slice(0, midpoint);
    const rightColumn = admins.slice(midpoint);
    return { leftColumn, rightColumn };
  };

  return (
    <TableSection title="">
      <AnimatePresence mode="wait">
        {isLoading ? (
          <LoadingState />
        ) : admins.length === 0 ? (
          <EmptyState message="No global admins found" />
        ) : (
          <div className={isMobile ? 'grid grid-cols-1' : 'grid grid-cols-2 gap-2'}>
            <div className="divide-y divide-[var(--anl-border)]">
              {splitAdmins().leftColumn.map(admin => (
                <UserRow
                  key={admin.registrantid}
                  admin={admin}
                  getUserName={getUserName}
                  icon={
                    <span
                      className="mr-2 flex h-6 w-6 shrink-0 items-center justify-center rounded-full"
                      style={{ backgroundColor: 'var(--anl-accent)' }}
                    >
                      <Globe className="h-3 w-3 text-white" />
                    </span>
                  }
                />
              ))}
            </div>
            <div className="divide-y divide-[var(--anl-border)]">
              {splitAdmins().rightColumn.map(admin => (
                <UserRow
                  key={admin.registrantid}
                  admin={admin}
                  getUserName={getUserName}
                  icon={
                    <span
                      className="mr-2 flex h-6 w-6 shrink-0 items-center justify-center rounded-full"
                      style={{ backgroundColor: 'var(--anl-accent)' }}
                    >
                      <Globe className="h-3 w-3 text-white" />
                    </span>
                  }
                />
              ))}
            </div>
          </div>
        )}
      </AnimatePresence>
    </TableSection>
  );
};
